import '../../style/index.less';
import './index.less';
//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/grid/style/index.js
// module id = 187
// module chunks = 0